import React from 'react';
import { ContentfulPage } from '../common/ContentfulPage';
import { contentfulPages } from '../../services/constants';

const PrivacyPolicyScreen = ({ language }) => (
  <ContentfulPage
    contentfulKey={contentfulPages.PRIVACY_POLICY}
    language={language}
  />
);

export { PrivacyPolicyScreen };
